import { render, staticRenderFns } from "./ManageContacts.vue?vue&type=template&id=cab4142e&"
import script from "./ManageContacts.vue?vue&type=script&lang=js&"
export * from "./ManageContacts.vue?vue&type=script&lang=js&"
import style0 from "./ManageContacts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports